import { z } from "zod";

const sportSubcategorySchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
  display_name: z.string(),
  slug: z.string(),
  sport_type: z.string(),
});

const sportCategorySchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
  display_name: z.string(),
  slug: z.string(),
  subcategories: z.array(sportSubcategorySchema).catch([]),
});

type SportSubcategory = z.infer<typeof sportSubcategorySchema>;
type SportCategory = z.infer<typeof sportCategorySchema>;

export {
  sportCategorySchema,
  sportSubcategorySchema,
  type SportCategory,
  type SportSubcategory,
};
